import React from "react";
import {Redirect, Route} from "react-router-dom";
import Cookies from "js-cookie";

function PrivateSiteRoute({component: Component, render, ...rest}) {
    return (
        <Route
            {...rest}
            render={({location}, props) =>
                Cookies.get("site_id") !== undefined && Cookies.get("as") === "site" ? (
                    Component ? (
                        <Component {...props} />
                    ) : (
                        render()
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: {from: location},
                        }}
                    />
                )
            }
        />
    );
}

export default PrivateSiteRoute;
